module.exports = __webpack_public_path__ + "media/favicon/favicon-16x16-22ae37cb.png";